import { GetPersonsListMinifiedResponseType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { MappedPersonsListMinifiedType } from './types';

export const mapGetPersonsListMinifiedResponseType = (
  apiType: GetPersonsListMinifiedResponseType
): MappedPersonsListMinifiedType => {
  return apiType.data.map(mapLinkableEntityType);
};
